export default {
  Model: {},
  Actions: {
    FETCH_CALENDAR_MEETINGS_SUCCESS: 'calendarMeetings/FETCH_CALENDAR_MEETINGS_SUCCESS',
  },
  State: {
    CALENDAR_MEETINGS_IDS_BY_DAY: 'CALENDAR_MEETINGS_BY_DAY',
    CALENDAR_MEETINGS_BY_ID: 'CALENDAR_MEETINGS_BY_ID',
  },
};
